<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex/dist/vuex.cjs.js";
import Pagination from "../../../components/pagination.vue";
import Swal from "sweetalert2";
import formatter from "../../../mixins/formatter";
// import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    page: {
        title: "Archive",
        meta: [
            {
                name: "description",
                content: appConfig.description,
            },
        ],
    },
    mixins:[formatter],
    components: {
        Layout,
        PageHeader,
        Pagination
    },
    data() {
        return {
            title: "Activity Logs",
            totalWingband: 0,
            loading: true,
            filter: {
                page: "",
                search: "",
                username: "",
                role: "",
                date: "",
                limit: 10,
            },
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
        };
    },
    created() {
        const total = this.$route.query.totalWingband;
        this.totalWingband = total ? parseInt(total, 10) : 0;
    },
    methods: {
        ...mapActions("activityLogs", {
            activityList: "getList",
        }),
        convertToCsv(objArray) {
            var array =
                typeof objArray != "object" ? JSON.parse(objArray) : objArray;

            var str = "";

            for (var i = 0; i < array.length; i++) {
                var line = "";
                for (var index in array[i]) {
                    if (line != "") line += ",";
                    line += array[i][index];
                }

                str += line + "\r\n";
            }

            return str;
        },
        exportCsvFile(headers, item, fileTitle) {
            var vm = this;
            if (headers) {
                item.unshift(headers);
            }
            var jsonObject = JSON.stringify(item);
            var csv = vm.convertToCsv(jsonObject);

            var exportedFilenmae = fileTitle + ".csv" || "export.csv";

            var blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, exportedFilenmae);
            } else {
                var link = document.createElement("a");
                if (link.download !== undefined) {
                    var url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", exportedFilenmae);
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        resetFilter(){
            this.filter.role = '';
            this.filter.username = '';
            this.filter.date = '';
            this.filter.limit = 10;
            this.initList(1);
        },
        filterData() {
            this.initList(1);
        },
        async initList(p) {
            var pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
                order: "desc",
            };
            if(this.filter.username){
                pl['username'] = this.filter.username;
            }
            if(this.filter.role){
                pl['role'] = this.filter.role;
            }
            if(this.filter.date){
                pl['date'] = this.filter.date;
            }
            this.loading = true;
            const data = await this.activityList(pl);
            this.loading = false;
            this.data.list = data.data;
            this.data.links = data.links;
            this.data.current_page = data.current_page;
            this.data.per_page = data.per_page;
            this.data.last_page = data.last_page;
        },
        async printFunction() {
            window.print();
        },
        async exportData() {
            var current = new Date();
            var currentDate = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
            var headers = {
                stag_number: "STAG REGISTRY",
                wingband_number: "WINGBAND #",
                breeders: "NAME OF BREEDERS",
                farm_name: "FARM NAME",
                farm_address: "FARM ADDRESS",
                province: "PROVINCE",
                feather_color: "FEATHER COLOR",
                leg_color: "LEG COLOR",
                comb_shape: "COMB SHAPE",
                nose_marking: "NOSE MARKING",
                feet_marking: "FEET MARKING",
            };
            var itemsFormatted = [];
            const arr = await this.data.list;
            arr.forEach((item) => {
                itemsFormatted.push({
                    stag_number: item.stag_number,
                    wingband_number: item.wingband_number,
                    breeders: item.breeders,
                    farm_name: item.farm_name,
                    farm_address: item.farm_address,
                    province: item.province,
                    feather_color: item.feather_color,
                    leg_color: item.leg_color,
                    comb_shape: item.comb_shape,
                    nose_marking: item.nose_marking,
                    feet_marking: item.feet_marking,
                });
            });
            var fileTitle = `Archive List - ${currentDate}`;
            this.exportCsvFile(headers, itemsFormatted, fileTitle);
        },
        // async exportToPDF() {
        //     const doc = new jsPDF();
        //     for (let i = 0; i < this.data.list.length; i++) {
        //         var data = this.data.list[i];
        //         if (data) {
        //             doc.text(`Archive List`, 85, 10);
        //             doc.text(`Chapter : ${data.chapter}`, 20, 30);
        //             doc.text(`Banded Cockerels : ${data.banded_cockerels}`, 20, 40);
        //         }
        //     }
        //     doc.save(`summary.pdf`);
        // },
        async unArchive(id) {
            var pl = {
                id: id,
                status: 1,
            }
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "Do you want to restore this record?",
                type: "warning",
                showCancelButton: true,
                icon: "warning",
                padding: "2em",
            }).then((result) => {
                return result.isConfirmed;
            });
            if (confirmed) {

                const res = await this.archive(pl);
                console.log(res);
                if (res.message == "Wingband updated successfully.") {
                    Swal.fire({
                        icon: "success",
                        title: "Remove record successful",
                        text: res.message,
                        timerProgressBar: true,
                        timer: 2000
                    });
                    this.initList(1)
                } else {
                    var error = res.message;
                    Swal.fire({
                        icon: "error",
                        title: "Failed!",
                        type: "error",
                        text: error,
                    });
                }
            }
        },
    },
    mounted() {
        this.initList(1);
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        <div class="row">
            <div class="col-lg-12">
                <div class="card p-0">
                    <div class="card-body p-0">
                        <div class="d-flex flex-wrap p-3">
                            <div class="col-12">
                                <div class="d-flex flex-wrap align-items-end gap-2">
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Username:</label>
                                        <input type="text" class="form-control" placeholder="Search..." v-model="filter.username">
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Role:</label>
                                        <select class="form-control" v-model="filter.role">
                                            <option value="1">Admin</option>
                                            <option value="3">Encoder</option>
                                            <option value="2">Viewer</option>
                                        </select>
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Date:</label>
                                        <input type="date" class="form-control" placeholder="Search..." v-model="filter.date">
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <label class="filter-label">Limit:</label>
                                        <select class="form-control w-50" v-model="filter.limit" @change="filterData()">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                            <option value="200">200</option>
                                            <option value="500">500</option>
                                            <option value="1000">1000</option>
                                            <option value="5000">5000</option>
                                        </select>
                                    </div>
                                    <div class="disflex custom-border p-1">
                                        <button class="btn btn-success mx-1" @click="initList(1)">Filter</button>
                                        <button class="btn btn-light mx-1" @click="resetFilter()">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="pt-3 custom-overflow">
                            <table class="mb-0 table">
                                <thead>
                                    <tr class="bg-light">
                                        <th style="width: 30px !important;">#</th>
                                        <th style="width: 20% !important;">USERNAME</th>
                                        <th>ROLE</th>
                                        <th style="width: 20% !important;">ACTION</th>
                                        <th>DESCRIPTION</th>
                                        <th>DATE</th>
                                    </tr>
                                </thead>
                                <tbody v-if="!loading">
                                    <tr v-for="(data, index) in data.list" :key="index">
                                        <td style="width: 30px !important;">{{ index + 1}}</td>
                                        <td style="width: 20% !important;">{{ data.username }}</td>
                                        <td>{{ data.role }}</td>
                                        <td style="width: 20% !important;">{{ data.description }}</td>
                                        <td>
                                            <div class="text-start ms-3" v-if="data.description == 'Update Wingband'">
                                                <h6 class="fw-bolder">DATA</h6>
                                                <ul>
                                                    <li>Function =  {{ data.function }}</li>
                                                    <li>Description =  {{ data.description }}</li>
                                                    <li>Username =  {{ data.username }}</li>
                                                    <li>User ID =  {{ data._id }}</li>
                                                    <li>Status =
                                                        <span :class="data.status == 'success' ? 'text-success':'text-danger'">
                                                            {{ data.status }}
                                                        </span>
                                                    </li>
                                                    <li>From:
                                                        <ul v-html="formatJsonString(data.old_value)"></ul>
                                                    </li>
                                                    <li>To:
                                                        <ul v-html="formatJsonString(data.new_value)"></ul>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="text-start ms-3" v-else-if="data.description == 'Delete Wingband'">
                                                <h6 class="fw-bolder">DATA</h6>
                                                <ul>
                                                    <li>Function =  {{ data.function }}</li>
                                                    <li>Description =  {{ data.description }}</li>
                                                    <li>Username =  {{ data.username }}</li>
                                                    <li>User ID =  {{ data._id }}</li>
                                                    <li>Status =
                                                        <span :class="data.status == 'success' ? 'text-success':'text-danger'">
                                                            {{ data.status }}
                                                        </span>
                                                    </li>
                                                    <li>Deleted Data:
                                                        <ul v-html="formatJsonString(data.table_data,'delete-wingband')"></ul>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="text-start ms-3" v-else-if="data.description == 'Bulk Delete Wingband' || data.description == 'Bulk Delete'">
                                                <h6 class="fw-bolder">DATA</h6>
                                                <ul>
                                                    <li>Function =  {{ data.function }}</li>
                                                    <li>Description =  {{ data.description }}</li>
                                                    <li>Username =  {{ data.username }}</li>
                                                    <li>User ID =  {{ data._id }}</li>
                                                    <li>Status =
                                                        <span :class="data.status == 'success' ? 'text-success':'text-danger'">
                                                            {{ data.status }}
                                                        </span>
                                                    </li>
                                                    <li>Deleted Records:
                                                        <ul v-html="formatJsonString(data.table_data,'bulk-delete-wingband')"></ul>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="text-start ms-3" v-else-if="data.description == 'Create User'">
                                                <h6 class="fw-bolder">DATA</h6>
                                                <ul>
                                                    <li>Function =  {{ data.function }}</li>
                                                    <li>Description =  {{ data.description }}</li>
                                                    <li>User ID =  {{ data._id }}</li>
                                                    <li v-for="(item, index) in formatJsonString(data.request,'create-user')" :key="index">
                                                        {{item}}
                                                    </li>
                                                    <li>Status =
                                                        <span :class="data.status == 'success' ? 'text-success':'text-danger'">
                                                            {{ data.status }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="text-start ms-3" v-else>
                                                <h6 class="fw-bolder">DATA</h6>
                                                <ul>
                                                    <li>Function =  {{ data.function }}</li>
                                                    <li>Description =  {{ data.description }}</li>
                                                    <li>Username =  {{ data.username }}</li>
                                                    <li>User ID =  {{ data._id }}</li>
                                                    <li>Status =
                                                        <span :class="data.status == 'success' ? 'text-success':'text-danger'">
                                                            {{ data.status }}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                        <td>
                                            <span>{{  `${dateOnly(data.created_at)} ${timeOnly(data.created_at)}` }}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <div v-if="loading" class="loader">Loading...</div>
                        </div>
                    </div>
                    <Pagination :data="data" @emitPage="initList" class="me-2" />
                </div>
            </div>
        </div>
    </Layout>
</template>

<style scoped>
th,
td {
    width: 75px !important;
    text-align: center;
}

.table> :not(caption)>*>* {
    text-align: center;
    padding: .5rem .1rem !important;
}

th {
    text-transform: uppercase;
}
</style>